import { FC } from 'react'
import s from './index.module.less'
import { renderTime } from '@/utils/common'
import { type VipType, VIP_TYPE_MAP } from '@/consts/newConsts'
import TopsDetail from '@/layout/Main/HeaderBar3/TopsDetail'
import VipDetail from '@/layout/Main/HeaderBar3/VipDetail'



interface Props {
  userInfo: any
  openVipRechargeModal: () => void
  onBuyTopsClick?: () => void
}
const RechargeInfo: FC<Props> = (props) => {
  const { userInfo, openVipRechargeModal, onBuyTopsClick } = props
  return (
    <div
      className={`${s.rechargeBtn}`}
      onClick={() => {
        openVipRechargeModal()
      }}>
      <TopsDetail userInfo={userInfo} onBuyClick={openVipRechargeModal} onBuyTopsClick={onBuyTopsClick}>
        <div className={s.topsBox}>
          <span className={s.iconTops}></span>
          <span className={s.lg_txt}>{(userInfo && userInfo.total_tops) || 0}</span>
        </div>
      </TopsDetail>

      <div className={s.divider}></div>
      {(() => {
        const activeVips = (userInfo?.vip_info || []).filter((item: any) => item.is_vip)
        const vipText = (
          <div className={s.lg_txt_box}>
            <span className={s.lg_txt1}>
              {(() => {
                // 从 vip_info 中筛选已开通的会员，取最高等级展示
                if (activeVips.length === 0) {
                  return <span className={s.lg_txt2}>开会员 得算力</span>
                }
                const topVip = activeVips.reduce((max: any, item: any) =>
                  item.vip_type > max.vip_type ? item : max
                )
                const vipName = VIP_TYPE_MAP[topVip.vip_type as VipType]
                return (
                  <span>{vipName}<span className={s.lg_txt2}>{renderTime(topVip.vip_end_time * 1000, 'YYYY-M-D')}</span>到期</span>
                )
              })()}
            </span>
          </div>
        )
        // 只有拥有两个及以上等级会员时才展示 VipDetail 弹层
        return activeVips.length >= 2 ? (
          <VipDetail userInfo={userInfo}>{vipText}</VipDetail>
        ) : (
          vipText
        )
      })()}
    </div>
  )
}
export default RechargeInfo
